import EmployeePayTable from "@shared-containers/EmployeePayTable";
import { CustomCardWrapper } from "./style";

const EmployeePayAll = () => {
  return (
    <CustomCardWrapper>
      <EmployeePayTable pagination />
    </CustomCardWrapper>
  );
};

export default EmployeePayAll;
